module.exports = __webpack_public_path__ + "static/media/brand-tooltip.dba3024f.svg";